import { render, staticRenderFns } from "./Jrfw.vue?vue&type=template&id=9baa157c&scoped=true"
import script from "./Jrfw.vue?vue&type=script&lang=js"
export * from "./Jrfw.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9baa157c",
  null
  
)

export default component.exports